// src/pages/CrmCustomers/index.js
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Tabs } from "antd";
import CrmCustomerList from "./components/CrmCustomerList";
import { fetchCrmCustomers, fetchCrmCustomerGroups } from "./crmCustomersThunks";

const CrmCustomers = ({authInfo}) => {
  const dispatch = useDispatch();
  const { crmCustomers } = useSelector((s) => s.crmCustomers);

  useEffect(() => {
    dispatch(fetchCrmCustomers());
    dispatch(fetchCrmCustomerGroups());
  }, [dispatch]);

  return (
    <Tabs
      defaultActiveKey="customers"
      type="card"
      size="medium"
      items={[
        {
          label: "CRM Customers",
          key: "customers",
          children: <CrmCustomerList crmCustomers={crmCustomers} authInfo={authInfo}/>
        },
      
      ]}
    />
  );
};

export default CrmCustomers;
